const getFeatureCoordinates = (feature) => ({
  lng: feature.geometry.coordinates[0],
  lat: feature.geometry.coordinates[1],
});

export const buildSelectedVehicleItem = (feature) => {
  const { lng, lat } = getFeatureCoordinates(feature);

  return {
    type: "vehicle",
    id: feature.properties.vehicleId,
    routeId: feature.properties.routeId,
    routeLabel: feature.properties.routeLabel,
    routeColor: feature.properties.routeColor,
    routeTextColor: feature.properties.routeTextColor,
    routeType: feature.properties.routeType,
    serviceName: feature.properties.serviceName,
    bearing: feature.properties.bearing,
    lng,
    lat,
    direction: feature.properties.directionId,
    trip_id: feature.properties.tripId,
    startDate: feature.properties.startDate,
    startTime: feature.properties.startTime,
    occupancyStatus: feature.properties.occupancyStatus,
    selected: true,
  };
};

export const vehicleMapSelectionConfig = {
  type: "vehicle",
  queryKey: "vehicle",
  buildSelectedItem: buildSelectedVehicleItem,
};
